import { inject } from 'mobx-react'
import React, { useEffect } from 'react'
import { PERSON_STORE } from 'store'
import styles from './EditPersonPage.module.scss'
import cl from 'classnames'
import { EditPersonPageProps } from './EditPersonPage.types'
import { PersonInfoSection } from './PersonInfoSection'
import { ProjectsSection } from './ProjectsSection'
import { PageHeader, RelatedMediaSection } from 'components/shared'
import { Project } from 'models'
import { observer } from 'mobx-react-lite'
import { IconPeople } from 'assets'
// import { RelatedMediaSection } from './RelatedMediaSection'

const EditPersonPageComponent = (props: EditPersonPageProps) => {
  const {
    match: { params: { id } },
    history: { push },
    [PERSON_STORE]: {
      getPersonById,
      personToView,
      editPerson
    }
  } = props

  useEffect(() => getPersonById(id), [getPersonById, id])

  const onRelatedMediaChange = (relatedMedia: Project[]) => {
    editPerson({
      ...personToView.asDTO,
      relatedMedia: (relatedMedia || personToView.relatedMedia || []).map(p => p.asDTO)
    })
  }

  return (
    <div className={cl(styles.pageContainer, styles.scrollable)} style={ { overflowX: 'hidden' } }>
      <PageHeader
        navSegments={[
          {
            label: 'People',
            icon: IconPeople,
            onClick: () => push('/persons')
          },
          {
            label: personToView.name
          }
        ]}
      />
      <PersonInfoSection />
      <ProjectsSection />
      <RelatedMediaSection
        relatedMedia={personToView.relatedMedia}
        onChange={onRelatedMediaChange}
      />
    </div>
  )
}

const EditPersonPage = inject(PERSON_STORE)(observer(EditPersonPageComponent))
export { EditPersonPage }
